(function () {
    let triggeredFunctionalTags = false;
    let triggeredAnalyticTags = false;
    let triggeredMarketingTags = false;

    function triggerEvent(name) {
        const event = new Event(name, {
            bubbles: true,
            cancelable: false,
        });

        document.body.dispatchEvent(event);
    }

    function triggerC24Events() {
        if (!triggeredFunctionalTags && window.c24LpCookieConsent?.indexOf('f') !== -1) {
            triggeredFunctionalTags = true;
            triggerEvent('c24LpLoadFunctionalTags');
        }

        if (!triggeredAnalyticTags && window.c24LpCookieConsent?.indexOf('a') !== -1) {
            triggeredAnalyticTags = true;
            triggerEvent('c24LpLoadAnalyticTags');
        }

        if (!triggeredMarketingTags && window.c24LpCookieConsent?.indexOf('m') !== -1) {
            triggeredMarketingTags = true;
            triggerEvent('c24LpLoadMarketingTags');
        }
    }

    window.addEventListener('c24consent', function (e) {

        if (!e.detail || !e.detail.c24consent) {
            return;
        }

        if (window.c24LpCookieConsent === e.detail.c24consent) {
            return;
        }

        window.c24LpCookieConsent = e.detail.c24consent;

        triggerC24Events();

    }, false);

    triggerC24Events();

}());
